// filepath: apps/web/src/features/admin/effects/HttpEndpointsRoute.tsx
//
// FR-UI-ADM-8 AC-3 -- route shell for the HTTP endpoint admin editor.
// URL: /admin/effects/http-endpoints
//
// The route enforces the staging-only gate at the SPA layer
// (defense-in-depth; the server rejects production writes with
// HTTP 403 ENV_PRODUCTION on POST/PATCH/DELETE).

import React from "react";
import { StagingOnlyError } from "@/features/admin/StagingOnlyError";
import { HttpEndpointsPage } from "./HttpEndpointsPage";

interface HttpEndpointsRouteProps {
  environmentKind: string;
}

export function HttpEndpointsRoute({
  environmentKind,
}: HttpEndpointsRouteProps): React.ReactElement {
  if (environmentKind !== "staging") {
    return <StagingOnlyError environmentKind={environmentKind} />;
  }
  return <HttpEndpointsPage environmentKind={environmentKind} />;
}
